import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/home/home.vue'),
    meta:{ title:'家长端' }
  },
  {
    path: '/clock',
    name: 'Clock',
    component: () => import('../views/clock/clock.vue'),
    meta:{ title:'家长打卡' }
  },
  {
    path: '/report/list',
    name: 'ReportList',
    component: () => import('../views/report/list.vue'),
    meta:{ title:'报告列表' }
  },
  {
    path: '/report/create',
    name: 'ReportCreate',
    component: () => import('../views/report/create.vue'),
    meta:{ title:'生成报告' }
  },
  {
    path: '/report/detail',
    name: 'ReportDetail',
    component: () => import('../views/report/detail.vue'),
    meta:{ title:'报告详情' }
  },
  {
    path: '/studentBinding',
    name: 'StudentBinding',
    component: () => import('../views/studentBinding/studentBinding.vue'),
    meta:{ title:'学生信息绑定' }
  },
  {
    path: '/lecture',
    name: 'Lecture',
    component: () => import('../views/lecture/lecture.vue'),
    meta:{ title:'护眼大讲堂' }
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('../views/test/test.vue'),
    meta:{ title:'视力自测' }
  },
  {
    path: '/record',
    name: 'Record',
    component: () => import('../views/record/record.vue'),
    meta:{ title:'视力档案' }
  },
  {
    path: '*',
    name: '404',
    component: () => import('@/views/error/404'),
  },
]

//项目中遇到如下报错内容：Uncaught (in promise) Error: Redirected when going from "/video" to "/user" via a navigation guard.
//原因：vue-router路由版本更新产生的问题,导致路由跳转失败抛出该错误，但并不影响程序功能
//全局解决：替换路由的Push和replace方法
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  routes
})

export default router
